<template>
  <div class="">
    <b-button v-b-toggle.EnquiryReservations class="btn btn-lg btn-collapse">
      {{ $t("pages.EnquiryReservations") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="EnquiryReservations">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="enquiryReservationsView"
              v-model="
                usersPrivilegeEnquiryReservations.enquiryReservationsView
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="enquiryReservationsView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="enquiryReservationsAdd"
              v-model="usersPrivilegeEnquiryReservations.enquiryReservationsAdd"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="enquiryReservationsAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="enquiryReservationsDelete"
              v-model="
                usersPrivilegeEnquiryReservations.enquiryReservationsDelete
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="enquiryReservationsDelete">{{
              $t("delete")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeEnquiryReservations",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeEnquiryReservations"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
